/**
 * RelecteursAdminPage — les adresses de relecture dans « Listes & annuaires ».
 *
 * Le panneau vit aussi en bas de la page Arrêtés, là où l'agent en a besoin au
 * quotidien. Cette entrée admin le rend trouvable au même endroit que les autres
 * listes (Lieux, Prestataires, Annuaire) : quelqu'un qui cherche « où on gère
 * les adresses » n'a plus à deviner dans quelle brique regarder.
 *
 * Même composant, deux points d'entrée — pas de duplication de logique.
 */
import { SectionEyebrow } from '@/components/ui';
import { RelecteursPanel } from '@/pages/service-technique/RelecteursPanel';

export function RelecteursAdminPage() {
  return (
    <div className="space-y-6">
      <div>
        <SectionEyebrow as="div">Listes &amp; annuaires</SectionEyebrow>
        <h1 className="text-2xl font-semibold text-ink">Adresses de relecture</h1>
        <p className="mt-1 text-sm text-ink-muted">
          Personnes sollicitées pour relire un arrêté avant signature. Elles n'ont pas
          besoin d'un compte : un nom et une adresse email suffisent.
        </p>
      </div>
      <RelecteursPanel />
    </div>
  );
}
